<template>
  <RunningCard>
    <template #header>
      <div class="running-pendding-header">
        <img src="../../../assets/img-v2/ic_running_clock.png" class="icon" />
        <div class="text">
          <div class="text-on">已上车</div>
          <div v-if="isPendding && offTime" class="text-desc">
            预计
            <span class="text-time">{{ offTime }}</span>
            到达下车点
          </div>
        </div>
      </div>
    </template>
    <template #content>
      <RunningSummary :orderInfo="orderInfo" />
    </template>
  </RunningCard>
</template>

<script>
import RunningCard from "./RunningCard.vue";
import RunningSummary from "./RunningSummary.vue";

export default {
  name: "RunningPendding",
  components: {
    RunningCard,
    RunningSummary,
  },
  props: {
    orderInfo: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {};
  },
  computed: {
    isPendding() {
      const { isPendding } = this.orderInfo || {};
      return isPendding;
    },
    offTime() {
      const { offTime } = this.orderInfo || {};
      return offTime;
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.running-pendding-header {
  padding: 9px 6px 13px 6px;
  display: flex;
  align-items: center;
  .icon {
    width: 54px;
    height: 54px;
  }
  .text {
    display: flex;
    align-items: baseline;
    font-family: PingFangSC, PingFang SC;
    color: #000000;
  }
  .text-on {
    font-weight: 600;
    font-size: 18px;
    line-height: 25px;
    margin: 0 7px 0 4px;
  }

  .text-desc {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
  }
  .text-time {
    font-family: DINAlternate, DINAlternate;
    font-weight: bold;
    font-size: 24px;
    color: #006efa;
    line-height: 28px;
  }
}
</style>
